import { useEffect, useState } from 'react';

import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';

import Button from 'components/shared/Buttons/Button';

import TPModal from '../../TreatmentPlan/TPModal';

const TreatmentPlan = () => {
  const [showTPModal, setShowTPModal] = useState(false);
  const [showTP, setShowTP] = useState(true);

  const { cnDisplaySettings, setSelectedTreatmentPlan } = useClinicalNoteContext();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1350) {
        setShowTP(true);
      } else {
        setShowTP(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!cnDisplaySettings?.treatment_plan?.enabled) return null;

  const openTPModal = () => {
    setSelectedTreatmentPlan({});
    setShowTPModal(true);
  };

  const closeTPModal = () => {
    setSelectedTreatmentPlan({});
    setShowTPModal(false);
  };

  if (!showTP) {
    return null;
  }

  return (
    <>
      <Button
        text="Treatment Plan"
        icon="task-1-linear"
        className="hover:!bg-primary-700"
        textClassName="text-white"
        shade={100}
        color="white"
        transparent
        size="small"
        onClick={openTPModal}
        data-qa="treatment-plan-btn"
      />
      {showTPModal && <TPModal isOpen={showTPModal} handleClose={closeTPModal} />}
    </>
  );
};

export default TreatmentPlan;
